import styled from 'styled-components';

export const KeyBinding = styled.div`
	padding: 2px;
	font-size: 14px;
	border: 1px solid ${(props) => props.theme.colors.lightBlue};
	border-bottom: 2px solid ${(props) => props.theme.colors.lightBlue};
	border-radius: 4px;
	background: white;
	font-size: 10px;
	color: ${(props) => props.theme.colors.slateBlue};
`;
